// 부스터(Vster) 디자인 토큰 — 프로토타입과 동일한 값.
//   각 값은 CSS 변수(--v-*)를 참조하되 폴백으로 기본(지원사업=블루) 값을 둔다. 인라인 style 도 var() 를
//   해석하므로, 상위 요소에 .theme-event(globals.css) 를 걸면 그 아래 전 컴포넌트가 행사 테마(보라)로
//   자동 재색상된다. 지원사업 페이지는 변수 미정의 → 폴백(블루) 그대로. (마감 램프·ok/warn/danger 등
//   의미색은 두 테마 공통이라 var 처리하지 않음.)
export const c = {
  bg: 'var(--v-bg, #F4F6FA)',
  surface: 'var(--v-surface, #FFFFFF)',
  surfaceAlt: 'var(--v-surfaceAlt, #EAEEF5)',
  ink: 'var(--v-ink, #0E1726)',
  muted: 'var(--v-muted, #5A6579)',
  line: 'var(--v-line, #DDE3EC)',
  action: 'var(--v-action, #2C5CFF)',
  actionDark: 'var(--v-actionDark, #1E45D6)',
  actionSoft: 'var(--v-actionSoft, #E7EDFF)',
  actionBorder: 'var(--v-actionBorder, #C7D3FF)',
  ok: '#1F9D6B',
  okText: '#12704B',
  okSoft: '#E8F5EF',
  warn: '#D9A400',
  warnText: '#7E5E00',
  danger: '#D93B3B',
  dangerText: '#C42C2C',
} as const;

/** 마감일 램프 — 배경 틴트용 색(c)과 AA 통과 텍스트 색(t) 쌍 */
export function ramp(d: number | null) {
  if (d === null) return { c: '#9AA5B5', t: c.muted, label: '마감됨', urgent: false };
  if (d <= 3) return { c: '#D93B3B', t: '#C42C2C', label: `D-${d}${d === 0 ? ' 오늘 마감' : ' 마감 임박'}`, urgent: true };
  if (d <= 7) return { c: '#E5761F', t: '#93400F', label: `D-${d} 마감 임박`, urgent: false };
  if (d <= 13) return { c: '#D9A400', t: '#7E5E00', label: `D-${d}`, urgent: false };
  return { c: '#1F9D6B', t: '#12704B', label: `D-${d}`, urgent: false };
}
